import React  from 'react'; // need this to use jsx (the html inside the array. noramally that would be in a string)
const value = {
  path:"appraiser",
  title:"Appraiser",
  date_modified:"April 2021",
  date_created:"April 2021",
  content:
[
<p align="justify">
Appraisers perform an assessment of the property you are interested in purchasing, to determine its value. This assessment is sometimes required by lenders; often, if the lender thinks the borrower is overpaying, they will require an appraisal. By knowing the real value of the property, lenders can be confident the funds will be repaid in the event of default, when the house is inevitably sold. If the appraisal finds the house is being purchased for more than it’s worth, the borrower will have to produce the difference in cash -- otherwise, they may no longer qualify for the mortgage. The appraisal is performed by an appraiser licensed under the National Appraisers Association of Real Estate Appraisers or the Appraisal Institute of Canada.
</p>
,
<p align="justify">
Usually, purchasers who are putting down less than 20% will not be required to get an appraisal. This is because the required mortgage default insurance will provide adequate protection, in the eyes of the lender. It’s also likely lenders will not require an appraisal when down-payments are more than 50% of the purchase price -- since this would be a very low ratio(risk) mortgage.
</p>
,
<p align="justify">
An appraisal costs between $300 and $500, and depending on the lender, the purchaser can be expected to foot the bill.  Even though the buyer might be required to pay for the appraisal, lenders will typically order the appraisal themselves -- from a company on their approved list. (3)
This means the buyer does not own the rights to the report. Since the lender is the actual client of the appraiser, it is up to them to decide if the buyer can see the result of the appraisal, and if they can take it with them to a new lender. Appraisals are ordered by the lender after an offer has been accepted, but before the mortgage has been finalized. If you are worried your mortgage won’t come through, because of the appraisal, be sure to include a financing condition in your offer.
</p>

],
  tags:["real estate professionals"]
}

export default value



// WEBPACK FOOTER //
// src/content/appraiser.js